import { TitleCasePipe } from '@angular/common';

export class Structure {
  id: number
  name: string
  tags: any[]

  constructor(data) {
    let titlecasePipe = new TitleCasePipe
    this.id = (data.structure_id || data.eventStructure_pk) ? parseInt((data.structure_id) ? data.structure_id : data.eventStructure_pk) : null
    this.name = (data.description || data.name) ? titlecasePipe.transform((data.description) ? data.description : data.name) : null
  }
}
